<template>
  <div class="login_block__01">
    <div class="login_mail">
      <h3>로그인</h3>
      <div class="renew2_flex id">
        <p class="title">로그인ID</p>
        <div class="input"><el-input v-model="mailLogin.email" type="email" autocomplete name="mail-link-input"
            placeholder="메일을입력하세요" :disabled="loginEmailSending"></el-input></div>
      </div>
      <div class="renew2_flex pw">
        <p class="title">패스워드</p>
        <div class="input"><el-input v-model="mailLogin.passwd" type="password" autocomplete name="mail-link-input"
            placeholder="패스워드를입력하세요" :disabled="loginEmailSending"></el-input></div>
      </div>
      <el-button type="primary" id="email-login-account-dialog" class="btn" :plain="isPlainButton"
        @click="$eventHub.$emit('login-id-passwd', mailLogin.email, mailLogin.passwd)"
        v-loading="loginEmailSending">로그인</el-button>
      <p style="text-align:center;"><a href="/kr/resume/repasswd">패스워드를 잊으신분</a></p>
    </div>
    <div class="login_sns">
      <h3>소셜 계정으로 로그인</h3>
      <ul class="renew2_flex sns_list">
        <li class="sns_list__item">
          <button class="renew2_flex renew2_sp_flex" @click="$firebase.signInGoogle();">
            <img src="/kr/resume/static/renew2_img/google.png" alt="Google">
            <p>Google 로그인</p>
          </button>
        </li>
        <li class="sns_list__item">
          <button class="renew2_flex renew2_sp_flex" @click="$firebase.signInApple();">
            <img src="/kr/resume/static/renew2_img/appleinc.png" alt="Apple">
            <p>AppleID 로그인</p>
          </button>
        </li>
        <li class="sns_list__item" v-if="false">
          <button class="renew2_flex renew2_sp_flex" @click="$firebase.signInFacebook();">
            <img src="/kr/resume/static/renew2_img/facebook.png" alt="Facebook">
            <p>Facebook 로그인</p>
          </button>
        </li>
      </ul>
      <div class="sns_list__link">
        <h3>메일로 등록 링크 발송</h3>
        <div class="renew2_flex maillink">
          <div class="input"><el-input v-model="mailLogin.email" type="email" autocomplete name="mail-link-input"
              placeholder="메일을입력하세요" :disabled="loginEmailSending"></el-input></div>
        </div>
        <el-button type="primary" id="email-login-account-dialog" class="maillink-btn" :plain="isPlainButton"
          @click="mailSubmit" v-loading="loginEmailSending">메일로 링크발송</el-button>
      </div>
    </div>
  </div>

</template>
<script>
export default {
  props: {
    isPlainButton: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      loginEmailSending: false,
      mailLogin: {
        email: ''
      },
      mailLoginRules: {
        email: [
          {
            required: true,
            message: '메일을 입력하세요',
            trigger: 'blur'
          },
          {
            required: true,
            type: 'email',
            message: '메일을 입력하세요',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    resetloginEmail: function () {
      this.mailLogin.email = ''
      this.loginEmailSending = false
      // this.$refs['mailLoginForm'].resetFields()
    },
    mailSubmit: function () {
      const app = this
      // this.$refs['mailLoginForm'].validate(async valid => {
      //   if (!valid) {
      //     return
      //   }
      app.$firebase.signInEmail(app.mailLogin.email)
      app.loginEmailSending = true
      // })
    }
  },
  mounted: function () {
    this.$eventHub.$on('sing-in-mail-send', this.resetloginEmail)
    this.$eventHub.$on('sing-in-mail-failed', this.resetloginEmail)
  },
  destroyed: function () {
    this.$eventHub.$off('sing-in-mail-send', this.resetloginEmail)
    this.$eventHub.$off('sing-in-mail-failed', this.resetloginEmail)
  }
}
</script>
